import { onMounted, onUnmounted } from 'vue';
import MagicAnchor from '@/Plugins/MagicAnchor';

const stickyClasses = ['is-sticky', 'is-sticky-m'];

// Syncs MagicAnchor.baseOffset and the sticky `top` with the current header height.
export function useHeaderOffset(headerRef) {
    let observer = null;

    const updateOffset = () => {
        const el = headerRef.value;
        if (!el) return;

        const isSticky = stickyClasses.some(c => el.classList.contains(c));

        MagicAnchor.baseOffset = isSticky ? el.clientHeight * -1 : 0;

        const pwaNavBar = document.querySelector('.js-top-navigation-bar');
        if (pwaNavBar && isSticky) {
            el.style.top = `${pwaNavBar.offsetHeight || 0}px`;
        }
    };

    onMounted(() => {
        if (!headerRef.value) return;

        updateOffset();
        observer = new ResizeObserver(updateOffset);
        observer.observe(headerRef.value);
    });

    onUnmounted(() => {
        observer?.disconnect();
    });
}
